import * as React from 'react';
import { useIntl } from 'react-intl';
import { FullscreenExitLine, FullscreenLine } from '@dropbox/dig-icons/assets';
import { useToggleFullScreenCallback } from 'js/file_viewer/api/navigation';
import { useIsFullscreen } from 'js/file_viewer/api/ui';
import { UserActionContext } from 'js/file_viewer/core/logging/constants';
import { useStabilizedCallback } from 'js/file_viewer/core/utils/useStabilizedCallback';
import { ToolbarIcon } from 'js/file_viewer/toolbar/utils';
export const FullscreenButton = ({ variant }) => {
    const intl = useIntl();
    const isFullScreen = useIsFullscreen();
    const toggleFullScreenCallback = useToggleFullScreenCallback();
    const onFullscreen = useStabilizedCallback(() => {
        toggleFullScreenCallback({ actionContext: UserActionContext.PreviewToolbar });
    });
    const fullScreenLabel = isFullScreen
        ? intl.formatMessage({ id: "VOB6G0", defaultMessage: "Exit full screen" })
        : intl.formatMessage({ id: "2iLco8", defaultMessage: "Full screen" });
    return (React.createElement(ToolbarIcon, { label: fullScreenLabel, onClick: onFullscreen, icon: isFullScreen ? FullscreenExitLine : FullscreenLine, disabled: false, variant: variant }));
};
FullscreenButton.displayName = "FullscreenButton"
//# sourceMappingURL=fullscreen_button.preenvesnextjs.map
